import { connect } from 'react-redux';
import React from 'react';
import Authentication from '../../authentication/Authentication';

const AuthenticationPage = ({
  dispatch, loginError, mfaAuthCode
}) => (
  <div>
    <div className="logoContainer">
      <img src="logo.png"
        alt="Ayla Logo"
      />
    </div>
    <div className="AuthenticationContainer">
      <div className="AuthenticationFormContainer">
        <Authentication dispatch={dispatch} error={loginError} authcode={mfaAuthCode} />
      </div>
    </div>
  </div>
);

export default connect(s => s)(AuthenticationPage);
